import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../../mockData';
import { MIDTOWN_GUIDES } from './midtownData';

const MidtownServices = () => (
  <section className="py-20 bg-white" data-testid="midtown-services">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-16">
      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-teal-700">Sessions & pricing</p>
        <h2 className="mt-3 text-3xl md:text-4xl font-serif text-gray-900">Swedish, deep tissue, or both.</h2>
        <p className="mt-4 text-gray-700">Every session is one-on-one. Tell me what's going on and I'll blend the techniques to match.</p>
        <ul className="mt-8 divide-y divide-gray-200 border-y border-gray-200">
          {services.map((s) => (
            <li key={s.id} className="flex items-baseline justify-between py-4" data-testid={`midtown-price-${s.duration}`}>
              <span className="text-gray-900">{s.duration} minutes <span className="text-gray-500 text-sm">· {s.description}</span></span>
              <span className="font-serif text-2xl text-teal-700">${s.price}</span>
            </li>
          ))}
        </ul>
        <Link to="/services-menu" className="mt-6 inline-flex items-center gap-2 text-teal-700 hover:text-teal-900 transition-colors duration-300" data-testid="midtown-full-menu-link">
          See the full menu, including facials <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-rose-600">From the blog</p>
        <h2 className="mt-3 text-3xl md:text-4xl font-serif text-gray-900">Midtown massage guides</h2>
        <ol className="mt-8 space-y-3">
          {MIDTOWN_GUIDES.map((g, i) => (
            <li key={g.to}>
              <Link to={g.to} className="group flex items-start gap-4 p-4 rounded-2xl hover:bg-rose-50 transition-colors duration-300" data-testid={`midtown-guide-link-${i}`}>
                <span className="font-serif text-2xl text-rose-400 w-8 shrink-0">{String(i + 1).padStart(2, '0')}</span>
                <span className="text-gray-800 group-hover:text-gray-900 group-hover:underline underline-offset-4">{g.title}</span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default MidtownServices;
